<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>RabbitMQ Comms &mdash; Code</h2>
				<p waBody="m" waColorText="quiet" waText>&#64;Inject, .publish&#40;&#41;, done. Or use the Angular directive.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Server: publish to a RabbitMQ group</div>
					<markdown [data]="mdContent_141" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Client: declarative subscription &#40;Java component&#41;</div>
					<markdown [data]="mdContent_142" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Setup: Maven + environment + module-info</div>
					<markdown [data]="mdContent_143" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
			</div>
		</div>
	</div>
</div>